import React, { useEffect } from 'react';
import { View } from 'react-native';
import Button from '../../../components/Button';

interface I_AuthorizeButton_Props {
  allowedToday: boolean;
  allowedTommorow: boolean;
  authorizeForToday: () => Promise<void>;
  authorizeForTommorow: () => Promise<void>;
  loadingToday: boolean;
  loadingTommorow: boolean;
  revokeForToday?: () => Promise<void>;
  revokeForTommorow?: () => Promise<void>;
}

const AuthorizeButtons = ({
  allowedToday,
  allowedTommorow,
  authorizeForToday,
  authorizeForTommorow,
  loadingToday,
  loadingTommorow,
  revokeForToday,
  revokeForTommorow
}: I_AuthorizeButton_Props) => {

  if (allowedToday && allowedTommorow) {
    return null;
  }

  return (
    <View
      style={{
        paddingHorizontal: 8,
        paddingTop: 16,
        paddingBottom: 24,
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}>
      <Button
        onPress={allowedToday ? revokeForToday : authorizeForToday}
        size="md"
        py="2"
        isLoading={loadingToday}
        isLoadingText='Authorizing ...'>
        {allowedToday ? 'Revoke authorization for today' : 'Authorize for today'}
      </Button>
      <Button
        onPress={allowedTommorow ? revokeForTommorow : authorizeForTommorow}
        size="md"
        py="2"
        isLoading={loadingTommorow}
        isLoadingText='Authorizing ...'>
        {allowedTommorow ? 'Revoke authorization for tomorrow' : 'Authorize for tomorrow'}
      </Button>
    </View>
  );
};

export default AuthorizeButtons;
